import { NavLink  } from 'react-router-dom';

export default function NavProfile() {
  	return (
  	    <div className="row">
  	        <div className="col-md-12">
  	            <div className="nav-align-top">
  	                <ul className="nav nav-pills flex-column flex-sm-row mb-6">
                        <li className="nav-item">
                            <NavLink to="/profile-user" className="nav-link">
                                <i className="bx bx-sm bx-user me-1_5"></i>
                                Profilo
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/profile-teams" className="nav-link">
                                <i className="bx bx-sm bx-group me-1_5"></i>
                                Teams
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/profile-projects" className="nav-link">
                                <i className="bx bx-sm bx-grid-alt me-1_5"></i>
                                Contratti
                            </NavLink>
                        </li>
  	                </ul>
  	            </div>
  	        </div>
  	    </div>
	);
}